const TagTypes = {
    deceased: "deceased",
    primary: "primary",
    secondary: "secondary",
    tertiary: "tertiary",
    quaternary: "quaternary",
    quinary: "quinary",
    complaint: "complaint",
    inverted: "inverted",
    sale: "sale",
    ai: "ai",
};
export default Object.freeze(TagTypes);
